/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface PartIn {
  /**
     * @minimum 1
     * @maximum 10000
     */
  part_number: number;
  etag: string;
}
